import { IVehicleAssets } from "./interfaces";
import dayjs from "dayjs";

export function SaveVehicleAssets(this: IVehicleAssets) {
  return {
    entityId: this.entityId,
    entityType: this.entityType,
    estimatedValue: this.estimatedValue,
    valuationAmount: this.valuationAmount,
    valuationDate:
      this.valuationDate && dayjs(this.valuationDate).isValid()
        ? dayjs(this.valuationDate).format("YYYY-MM-DD")
        : null,
    description: this.description,
    registrationNo: this.registrationNo,
    yearOrModel: this.yearOrModel,
    comment: this.comment,
  };
}
